import { Empty, FCC, IconButton } from "@dgs/core";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export const AdditionalList = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0;
`;

const AdditionalListItemWrapper = styled.li`
	display: grid;
	grid-template-columns: 1fr max-content;
	align-items: center;
	gap: ${({ theme }) => theme.spacing(2)};
	padding-top: ${({ theme }) => theme.spacing(4)};
	&:not(:last-child) {
		border-bottom: 1px solid ${({ theme }) => theme.colors.palette.grey[20]};
	}
`;

export const AdditionalListItem: FCC<{ onDelete: () => void }> = ({ onDelete, children }) => {
	const { t } = useTranslation();

	return (
		<AdditionalListItemWrapper>
			<div>{children}</div>
			<IconButton type="button" title={t("Delete")} icon="delete" onClick={onDelete} />
		</AdditionalListItemWrapper>
	);
};

export const EmptyAdditionalList = styled(Empty)`
	padding: ${({ theme }) => theme.spacing(4)} 0;
`;
